import { render, staticRenderFns } from "./answerPanel.vue?vue&type=template&id=64ad0a61&scoped=true&"
import script from "./answerPanel.vue?vue&type=script&lang=js&"
export * from "./answerPanel.vue?vue&type=script&lang=js&"
import style0 from "./answerPanel.vue?vue&type=style&index=0&id=64ad0a61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad0a61",
  null
  
)

export default component.exports